var _path, _path2, _path3, _path4, _ellipse, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrPhLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 18,
    viewBox: "0 0 76 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1944 16.1144C26.6297 16.8306 23.6312 16.4169 21.5982 14.5343C18.4884 11.6542 18.8781 6.30798 21.2184 3.67104C23.6195 0.78182 29.0074 0.332866 32.2379 3.08442C35.3478 5.96445 35.3164 11.2937 32.697 14.0752C32.5431 14.2386 32.3797 14.3944 32.2079 14.5422L35.8113 18H31.1119L29.1944 16.1144ZM30.5797 9.05887C30.4216 12.8372 28.6258 13.6921 26.6583 13.5435C24.1184 13.3516 23.2567 11.1461 23.455 8.52076C23.6533 5.89538 24.9064 3.84959 27.3764 4.03615C29.3438 4.18475 30.778 6.4335 30.5797 9.05887Z",
    fill: "#BD3437"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5015 1.72825H42.466C42.4799 1.72825 42.4942 1.72824 42.509 1.72823C43.6842 1.72754 47.8429 1.72511 47.7076 5.7652C47.609 8.70587 45.8271 9.14269 44.3188 9.51243C44.2492 9.5295 44.1802 9.54642 44.1119 9.56344C44.4838 9.65325 45.1614 10.169 45.7209 10.8124C46.2804 11.4558 48.3721 14.4298 49.4795 16.015H45.4582C45.3182 15.7939 45.1587 15.5413 44.9887 15.2722C44.146 13.9382 43.0449 12.1951 42.7889 11.8343C42.4042 11.2923 41.6991 10.5425 41.2795 10.56C40.9438 10.574 40.4286 10.5658 40.213 10.56V16.015H36.4714L36.5015 1.72825ZM40.2224 8.10332V4.29675H42.1962C42.8306 4.28109 44.0854 4.63512 44.029 6.17654C43.9726 7.71796 42.5486 8.10332 41.8437 8.10332H40.2224Z",
    fill: "#BD3437"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5059 1.72821H58.4704C59.6557 1.72821 63.7806 1.98084 63.7806 6.13439C63.7806 7.83077 63.6771 9.23496 61.71 10.4152C60.4412 11.1765 58.159 11.0927 57.471 11.0674C57.3758 11.0639 57.3112 11.0615 57.2839 11.0627C56.9482 11.0767 56.433 11.0685 56.2174 11.0627V16.015H52.4758L52.5059 1.72821ZM56.2268 8.55354V4.29684H58.3522C59.0354 4.27932 60.322 4.78951 60.2613 6.51321C60.2006 8.23692 58.7318 8.55354 57.9727 8.55354H56.2268Z",
    fill: "#284381"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2209 16.015V1.85687H68.5081V7.83252C68.6859 7.83252 69.6527 6.06679 72.0507 6.06679C74.9399 6.30095 75.2861 9.00596 75.1694 9.92173V16.015H72.0507C72.0406 14.1858 72.0265 10.7695 72.0507 10.2851C72.081 9.6795 71.7367 8.41205 70.244 8.35676C69.0322 8.31188 68.5485 9.59876 68.5081 10.2851V16.015H65.2209Z",
    fill: "#284380"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.35001,
    cy: 8.32456,
    rx: 4.08463,
    ry: 4.08463,
    fill: "#F3EB4F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6955 12.9074V6.14502H16.6436V12.9074C16.6436 14.9739 14.9683 16.6491 12.9018 16.6491H7.86713L5.82617 15.1751L7.86713 13.7011H12.9018C13.3402 13.7011 13.6955 13.3457 13.6955 12.9074Z",
    fill: "#BD3437"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.94801 3.74173L2.94801 10.5041L-4.00543e-05 10.5041L-4.06455e-05 3.74173C-4.08262e-05 1.67521 1.6752 -2.7811e-05 3.74172 -2.79917e-05L8.77642 -2.84318e-05L10.8174 1.474L8.77642 2.94802L3.74172 2.94803C3.30337 2.94803 2.94801 3.30338 2.94801 3.74173Z",
    fill: "#284381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrPhLogo);
export default __webpack_public_path__ + "static/media/QrPhLogo.44fd809a327b695681ca711ceb950ddc.svg";
export { ForwardRef as ReactComponent };